"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConfigurationBuilder = exports.createAmplifyContext = exports.Amplify = void 0;
/*
This file maps top-level exports from `aws-amplify`.
*/
var Amplify_1 = require("./Amplify");
Object.defineProperty(exports, "Amplify", { enumerable: true, get: function () { return Amplify_1.Amplify; } });
var configure_1 = require("./configure");
Object.defineProperty(exports, "createAmplifyContext", { enumerable: true, get: function () { return configure_1.createAmplifyContext; } });
var core_1 = require("@aws-amplify/core");
Object.defineProperty(exports, "createConfigurationBuilder", { enumerable: true, get: function () { return core_1.createConfigurationBuilder; } });
